import axios from 'axios';
import { SolarProvider, SolarUser, SolarUserList } from '../types/solar_user';
import { API_URL, axiosInstance } from './api_config';




export const addSolarUser = async (formData: any): Promise<SolarUser> => {
    const response = await axiosInstance.post(`${API_URL}/create_solar_users`, 
      
      formData);
    return response.data;
}

export const updateSolarUser = async (formData: any): Promise<SolarUser> => {
    const response = await axiosInstance.put(`${API_URL}/update_solar_users`, formData);
    return response.data;
}

export const getAllProviders = async (formData: any): Promise<SolarProvider> => {
    const response = await axiosInstance.post(`${API_URL}/get_all_providers`);
    return response.data;
}

export const getSolarUserList = async (formData: any): Promise<SolarUserList> => {
    const response = await axiosInstance.post(`${API_URL}/get_solar_users`);
    return response.data;
}